import { Button, Checkbox, Flex } from '@mantine/core';
import { TbChevronRight, TbInfoCircle } from 'react-icons/tb';

interface JurisdictionsActionsProps {
  isMergeAll: boolean;
  setIsMergeAll: (value: boolean) => void;
  isLoading: boolean;
  isDisabled: boolean;
  onExportClick: () => void;
}
export const JurisdictionsActions = ({
  isMergeAll,
  setIsMergeAll,
  isLoading,
  isDisabled,
  onExportClick
}: JurisdictionsActionsProps) => {
  return (
    <Flex
      id="export-drawer-jurisdictions-actions"
      align="center"
      justify="flex-end"
      gap="16px"
      mt="32px"
    >
      <Flex
        id="export-drawer-jurisdictions-merge-all"
        align="center"
        fz="14px"
        c="#101113"
        gap="8px"
      >
        <TbInfoCircle color="#228BE6" size={16} />
        Merge all ZIPs
        <Checkbox
          id="export-drawer-jurisdictions-merge-all-checkbox"
          disabled={isDisabled}
          size="xs"
          checked={isMergeAll}
          onChange={val => setIsMergeAll(val.target.checked)}
        />
      </Flex>
      <Button
        id="export-drawer-jurisdictions-export-button"
        disabled={isDisabled}
        onClick={onExportClick}
        size="xs"
        loading={isLoading}
        rightSection={<TbChevronRight size="16" />}
      >
        Export
      </Button>
    </Flex>
  );
};
